// Theme type and color definitions
// ThemePicker component was removed - use LightDarkToggle in page.tsx instead

export interface ThemeColors {
  base: string;
  bright: string;
  hue: number;
}

// 4 color themes (None + 3 colors) - used for dev theme cycling
export const colorThemes: { name: string; theme: ThemeColors | null }[] = [
  { name: "None", theme: null },
  { name: "Gold", theme: { base: "#FFD000", bright: "#FFF4C1", hue: 50 } },
  { name: "CR", theme: { base: "#FF5E00", bright: "#FFB300", hue: 22 } },
  { name: "PB", theme: { base: "#3A9656", bright: "#00FF55", hue: 140 } },
];
